// eslint-disable-next-line import/prefer-default-export
export const ABBREVIATIONS = {
  bookingEntry: 'BE',
  invoice: 'INV',
  quote: 'Q',
};
